module.exports = __webpack_public_path__ + "static/media/product_4.9a223318.png";